export const PRODUCT_CREATE_FORM_ID = Symbol();
